import { WinnersFeedSkeleton } from '@/components/markets/winners/winners-feed-skeleton';
import { ListingDiscoveryActionsSkeleton } from '@/components/shared/listing-discovery-actions-skeleton';
import { Skeleton } from '@/components/ui/app-skeleton';
import { LISTING_INDEX_PAGE_STACK_CLASS } from '@/lib/ui/layout';
import { cn } from '@/lib/ui/utils';

const SORT_PILL_KEYS = ['newest', 'top-volume', 'most-holders'] as const;

// Route-level Suspense fallback — mirrors `WinnersPage`: the title + action
// icons header, the sort/filter pill bar, and the responsive `WinnersFeed`
// table. The body reflows identically to the loaded feed: an 8-column table
// (desktop header + grid rows) at lg+, and tall stacked stat cards below lg.
// Sized to the loaded layout so the skeleton→hydrated swap reads as the Winners
// page with minimal shift.
export default function WinnersLoading(): React.ReactNode {
  return (
    <div className={cn('w-full min-w-0', LISTING_INDEX_PAGE_STACK_CLASS)} aria-busy="true">
      <div className="flex items-center justify-between gap-2">
        <Skeleton className="h-7 w-32 shrink-0" />
        <ListingDiscoveryActionsSkeleton />
      </div>

      <div className="flex items-center gap-2 overflow-hidden">
        {SORT_PILL_KEYS.map((key) => (
          <Skeleton key={key} className="h-9 w-28 shrink-0 rounded-control" />
        ))}
      </div>

      <WinnersFeedSkeleton />
    </div>
  );
}
